// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fixit-snackbar{height:100vh!important;z-index:555!important}.fixit-snackbar .v-snack__wrapper{bottom:50px!important;position:absolute!important}.fixit-snackbar__error .v-snack__wrapper,.fixit-snackbar__info .v-snack__wrapper{background-color:#fff!important;background-image:linear-gradient(var(--v-primary-opacity-12) 100%,var(--v-primary-opacity-12) 100%)}.fixit-snackbar__body--message-error,.fixit-snackbar__body--message-info{color:#222!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
